import Vue from 'vue';
import VueRouter from 'vue-router';

// 引入路由模块
import appointmentRoutes from './modules/appointment';
import steamRoutes from './modules/steam';

Vue.use(VueRouter);
const routes = [
  // 这里可以包含其他全局路由（如果有的话）
  ...appointmentRoutes,
  ...steamRoutes
];

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router;
